import { useQuery } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { ADAPTER_SVC_PARTNER_PORTAL_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { routeReplacer } from '~/Helpers/String.helper';
import { useProvider } from '~/Hooks';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import {
  IIntegrationChannel,
  IIntegrationChannelData,
} from '~/Models/DTO/IntegrationChannels.model';

export const useRequestLocationsChannels = (locationIds: string[], enabled: boolean) => {
  const { currentProvider } = useProvider();

  async function fetchLocationChannels(locationId: string) {
    let data = await requestReactQuery<IIntegrationChannelData>({
      url: routeReplacer(ADAPTER_SVC_PARTNER_PORTAL_URLS.GET_LOCATIONS_INTEGRATION_CHANNELS, {
        location: locationId,
      }),
      config: { method: 'GET' },
    });

    return data.data;
  }

  const query = useQuery<Record<string, IIntegrationChannel[]>, IErrorResponse>(
    [REQUEST_ACTIONS.LOCATION_CHANNELS, locationIds, currentProvider?.uuid],
    async () => {
      const data = await Promise.all(
        locationIds.map((locationId) => fetchLocationChannels(locationId)),
      );

      const result = data.reduce((acc, item) => {
        item.forEach((channel) => {
          if (!acc[channel.location_id]) {
            acc[channel.location_id] = [];
          }
          acc[channel.location_id].push(channel);
        });
        return acc;
      }, {} as Record<string, IIntegrationChannel[]>);

      return result;
    },
    {
      enabled,
    },
  );

  return query;
};
